import React from 'react'

export const heroContent = {
  title: (
    <h1 data-testid="data-rollover-title">
      Don’t just rollover your unused data.
      <br />
      Get money back for it.
    </h1>
  ),
  cta: 'View our data discount plans',
}
